import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Attach admin token (if present) to every request
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers["X-Admin-Token"] = token;
  return config;
});

// Auth
export const adminLogin = (password) =>
  client.post("/admin/login", { password }).then((r) => r.data);

// Products
export const getProduct = (id) => client.get(`/products/${id}`).then((r) => r.data);
export const getProducts = () => client.get("/products").then((r) => r.data);
export const createProduct = (data) => client.post("/products", data).then((r) => r.data);
export const updateProduct = (id, data) => client.put(`/products/${id}`, data).then((r) => r.data);
export const deleteProduct = (id) => client.delete(`/products/${id}`).then((r) => r.data);

// Enquiries
export const createEnquiry = (data) => client.post("/enquiries", data).then((r) => r.data);
export const getEnquiries = () => client.get("/enquiries").then((r) => r.data);
export const deleteEnquiry = (id) => client.delete(`/enquiries/${id}`).then((r) => r.data);

// Gallery
export const galleryImageUrl = (item) => `${BACKEND_URL}${item.image}`;
export const getGallery = () => client.get("/gallery").then((r) => r.data);
export const uploadGalleryImage = (file, onProgress, title = "") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("title", title);
  return client
    .post("/gallery", fd, { onUploadProgress: (e) => onProgress?.(Math.round((e.loaded * 100) / (e.total || 1))) })
    .then((r) => r.data);
};
export const deleteGalleryImage = (id) => client.delete(`/gallery/${id}`).then((r) => r.data);

export default client;
